module.exports = __webpack_public_path__ + "img/chuc-mung-2025.e3f1f46c.png";